// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__DIGE4","content":"styles_content__2W7hx"};